import keyboard from "../data/keyboard.json";
import typoPatterns from "../data/typos.json";

export function commaMistakes(text, random, probability = 0.25) {
  return text.replace(/,\s+/g, (match) => (random() < probability ? " " : match));
}

export function caseMistake(token, random, probability = 0.1) {
  if (!/\p{L}/u.test(token)) {
    return token;
  }

  return random() < probability ? token.toLowerCase() : token;
}

function patternTypo(token, random) {
  const entries = Object.entries(typoPatterns);

  for (let i = 0; i < entries.length; i += 1) {
    const [from, to] = entries[i];
    if (token.toLowerCase().includes(from) && random() < 0.35) {
      const index = token.toLowerCase().indexOf(from);
      return `${token.slice(0, index)}${to}${token.slice(index + from.length)}`;
    }
  }

  return token;
}

export function typo(token, random, probability = 0.08) {
  if (!token || !/\p{L}/u.test(token) || random() >= probability) {
    return token;
  }

  const letters = token.split("");
  const index = Math.floor(random() * letters.length);
  const lower = letters[index].toLowerCase();
  const neighbors = keyboard[lower];

  if (neighbors && neighbors.length > 0) {
    const replacement = neighbors[Math.floor(random() * neighbors.length)];
    letters[index] = letters[index] === lower ? replacement : replacement.toUpperCase();
    return letters.join("");
  }

  return patternTypo(token, random);
}
